import Button from "@material-ui/core/Button/Button";
import Grid from "@material-ui/core/Grid/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Loader } from "@common/handleErrorAndLoading/Loader";
import { IFetchState } from "src/itsf/fetch/fetcherUtils";

interface IParams {
    callState: IFetchState;
    label: string;
    name?: string;
    type: string;
    validate?(value?: string): undefined | string;
    goToInitialStep?(): void;
    handleFormSubmit(value: string): void;
    isValidOtp: boolean;
}

export const ForgotEmailForm = (props: IParams) => {
    const { label, type, handleFormSubmit, goToInitialStep, validate, name, callState, isValidOtp } = props;

    const { handleSubmit, errors, register } = useForm<{ form: string }>({ defaultValues: { form: "" } });
    const { t } = useTranslation(["forgotEmail", "common", "validation"]);

    const handleBeforeFormSubmit = handleSubmit((formData) => {
        handleFormSubmit(formData.form);
    });

    return (
        <form onSubmit={handleBeforeFormSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        disabled={callState.isLoading}
                        error={Boolean(errors.form)}
                        fullWidth
                        helperText={errors.form?.message} // To Fix
                        id={name}
                        inputRef={register({
                            required: t("validation:required"),
                            validate: validate ? validate : undefined,
                        })}
                        label={`${label} *`}
                        margin="dense"
                        name="form"
                        type={type}
                    />
                    {!isValidOtp && <Typography color="error">{t("validation:invalidOTP")}</Typography>}
                </Grid>
                <Grid item xs={12}>
                    <Grid container justify="center" spacing={2}>
                        {callState.isLoading && <Loader size={40} />}
                        {goToInitialStep && !callState.isLoading && (
                            <Grid item xs={12}>
                                <Button color="secondary" fullWidth variant="outlined" onClick={goToInitialStep}>
                                    {t("forgotEmail:back")}
                                </Button>
                            </Grid>
                        )}
                        {!callState.isLoading && (
                            <Grid item xs={12}>
                                <Button color="secondary" fullWidth type="submit" variant="contained">
                                    {t("common:continue")}
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </Grid>

                {callState.error && (
                    <Typography color="error">{callState.error.errorMessage || t("common:genericError")}</Typography>
                )}
            </Grid>
        </form>
    );
};
